import script from "./InsuranceCommentPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceCommentPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceCommentPopUp.vue?vue&type=style&index=0&id=f024efb4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f024efb4"]])

export default __exports__